import { InjectionProviderException } from "./InjectionProviderException";
export class InjectionProviderConfigException extends InjectionProviderException {
  constructor(scope, token, provider, message, messageTemplateValues, parent) {
    super(scope, token, provider, message, messageTemplateValues, parent);
    InjectionProviderConfigException.setPrototype(this);
  }

}
